import { useTranslation } from 'react-i18next'
import React from 'react'

import { useNavigation } from '../../../utils/contexts/NavigationContext'
import { useOpenExportModal } from '../../../utils/routes/modals/modalsActions'
import IconButton from '../../../components/actions/IconButton'
import PageHeaderPanel from '../../../components/presentation/PageHeaderPanel'

const ResumePageHeader = ({ form }) => {
  const { t } = useTranslation(['formResume', 'listForms'])
  const navigate = useNavigation()
  const openExportModal = useOpenExportModal()

  const title = t('formResume:title', { count: form.repliesCount })

  return (
    <PageHeaderPanel
      leftIcon={'BsArrowLeftShort'}
      leftAction={() => navigate('/forms')}
      title={form.name}
      subtitle={form.repliesCount + ' respostas'}
      mediumPadding
      noContainer
      side={
        <IconButton
          icon="BsFileSpreadsheet"
          color="white"
          onClick={() => openExportModal({ entity: 'formReply', filter: { formIds: [form.id] } })}
          transparent
          label={t('listForms:exportToExcel')}
        />
      }
    />
  )
}

export default ResumePageHeader
